import { TrainIdentifier } from "@vygruppen/vy-train-map";
import { TrainsGroupedBySeries } from "features/History/groupTrainSeries";
import {
  findRepresentativeTrainId,
  getDirection,
} from "features/VehicleSidebar/AffectedTrains/utils/utils";

import { InfrastructureForm as InfrastructureFormSchema } from "features/CenterContent/RoleContent/TrainMap/StretchBuilder/infrastructureEvents/types/formSchema";
import {
  DirectionEnum,
  TrainFormSchema,
} from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/TrainInfoModal/types/formSchema";
import { TrainEventTypeEnum } from "features/CenterContent/VehicleDetails/TrainDetails/TrainCondition/OperationalTrainInfo/types/trainEventTypeEnum";

type TrainSchema = TrainFormSchema;
type InfraSchema = InfrastructureFormSchema["infrastructureForm"];
export const formStateHasCustomField = (formState: TrainSchema | InfraSchema) =>
  (formState as TrainSchema)?.type === TrainEventTypeEnum.TRAIN_CUSTOM ||
  formState?.action?.type === "CUSTOM" ||
  formState?.reason?.type === "CUSTOM" ||
  (formState as InfraSchema)?.consequence?.type === "CUSTOM";
export const safeCapitalise = (text: string): string => {
  if (!text || text.length === 0) {
    return "";
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
};

export const getRepresentativeTrainIds = (
  allTrainSeries: TrainsGroupedBySeries,
) => {
  const even = Object.values(allTrainSeries).map((it) =>
    findRepresentativeTrainId(it, "even"),
  );
  const odd = Object.values(allTrainSeries).map((it) =>
    findRepresentativeTrainId(it, "odd"),
  );
  const representativeTrainIds = [...even, ...odd].filter(
    Boolean,
  ) as TrainIdentifier[];
  const trainIds: TrainIdentifier[] = representativeTrainIds.map((it) => it);
  return trainIds;
}; // We have the same function in backend, called "getTrainIdentifierGroup"

export const toTrainSerie = (trainNumber: string) => {
  if (trainNumber.length <= 1) return "x";
  if (trainNumber.length <= 2) {
    return `${trainNumber.slice(trainNumber.lastIndexOf("-") + 1, -1)}x`; // If you modify this, make sure '6x' still works for productionDeviation
  }
  return `${trainNumber.slice(trainNumber.lastIndexOf("-") + 1, -2)}xx`;
};

export const getRepresentativeTrainId = (
  representativeTrainIds: TrainIdentifier[],
  trainSerie: string,
  direction: DirectionEnum,
) =>
  representativeTrainIds.find(
    (it) =>
      toTrainSerie(it.identifier) === trainSerie &&
      getDirection(it) === direction,
  )!;
